import {
  useState,
  forwardRef,
} from 'react';
import type {
  FocusEvent,
  ForwardedRef,
  DetailedHTMLProps,
  TextareaHTMLAttributes,
} from 'react';
import classNames from 'classnames';

import styles from './Textarea.module.css';

type TextareaProps = DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & {
  invalid?: boolean;
};

const Textarea = (props: TextareaProps) => {
  const {
    ref,
    invalid = false,
    readOnly = false,
    disabled = false,
    autoFocus = false,
    className,
    onBlur,
    onFocus,
    ...rest
  } = props;

  // ##########################################################################
  // STATE
  // ##########################################################################

  const [focused, setFocused] = useState(autoFocus);

  // ##########################################################################
  // FUNCTIONS
  // ##########################################################################

  const handleFocus = (e: FocusEvent<HTMLTextAreaElement>) => {
    if (
      disabled ||
      readOnly
    ) return;

    setFocused(true);

    if (
      onFocus
    ) onFocus(e);
  };

  const handleBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    if (
      disabled ||
      readOnly
    ) return;
    setFocused(false);

    if (
      onBlur
    ) onBlur(e);
  };

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const textAreaClassName = classNames({
    [styles.textarea]: true,
    [styles.invalid]: invalid,
    [styles.focused]: focused,
    [styles.disabled]: disabled,
    [styles.readOnly]: readOnly,
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div className={textAreaClassName}>
      <textarea
        {...rest}
        ref={ref}
        readOnly={readOnly}
        disabled={disabled}
        autoFocus={autoFocus}
        onBlur={handleBlur}
        onFocus={handleFocus}
        className={styles.field}
      />
    </div>
  );
};

export default Textarea;
export type { TextareaProps };
